<template>
  <div class="messageBox">
    <div class="titlepush">
      <div>推播類型</div>
      <RT :options="VUE_APP_MULTI_COUPON ? '活動公告_發送多張票券_發送票券並推播'.split('_') : '活動公告_發送票券_發送票券並推播'.split('_')" id="RTSQR"
      :defaultValue="messageType" @input="messageType=$event;type='純文字'"></RT>
    </div>
    <div class="titlepush" v-if="messageType==='活動公告'" :style="{marginTop: '34px'}">
      <div>推播形式</div>
      <RT :options="'純文字_純圖片_圖文訊息'.split('_')" id="RTRound"
      :defaultValue="type" @input="type=$event"></RT>
    </div>
    <!-- <div class="titlepush" v-if="messageType==='發送票券並推播'" :style="{marginTop: '34px'}">
      <div>推播形式</div>
      <RT :options="'純文字_純圖片'.split('_')" id="RTRound"
      :defaultValue="type" @input="type=$event"></RT>
    </div> -->
    <template v-if="messageType==='活動公告'">
      <MessageText v-if="type==='純文字'" :style="{marginTop: '30px'}" :defaultValue="content" @input="content=$event"/>
      <MessageImage v-else-if="type==='純圖片'" :style="{marginTop: '30px'}" :defaultValue="content" @input="content=$event"/>
      <MessageCube v-else :style="{marginTop: '30px'}" :defaultValue="content" @input="content=$event"/>
    </template>
    <template v-if="messageType==='發送票券'">
      <MessageCoupon :defaultValue="coupon" @input="coupon=$event" :style="{marginTop: '35px'}"/>
    </template>
    <template v-if="messageType==='發送多張票券'">
      <MessageCoupons :defaultValue="coupons" @input="coupons=$event" :style="{marginTop: '35px'}"/>
    </template>
    <template v-if="messageType==='發送票券並推播'">
      <MessageCoupon :defaultValue="coupon" @input="coupon=$event" :style="{marginTop: '35px'}"/>
      <MessageText v-if="type==='純文字'" :style="{marginTop: '30px'}" :defaultValue="content" @input="content=$event"/>
      <!-- <MessageImage v-else-if="type==='純圖片'" :style="{marginTop: '30px'}" :defaultValue="content" @input="content=$event"/> -->
    </template>
    <template v-if="!processing">
    <Btns @cancel="clean();$emit('clean')" :align="'flex-end'" :style="{marginTop: '40px', paddingRight: '33px', width: '100%'}" :save="'推送'"
    @save="save" @temp="saveAs"
    v-if="(messageType==='發送多張票券'&&coupons.length>0)||messageType!=='發送多張票券'"
    />
    </template>
  </div>
</template>

<script>
import { getapi } from '../../../store/fetch'
import Btns from '../../../components/btn/btnsx3.vue'
import MessageCube from './imgNtext.vue'
import MessageImage from './image.vue'
import MessageText from './text.vue'
import MessageCoupon from './coupon.vue'
import MessageCoupons from './coupons.vue'
const VUE_APP_MULTI_COUPON = JSON.parse(process.env.VUE_APP_MULTI_COUPON)
export default {
  props: ['clear', 'processing'],
  components: {
    MessageText,
    MessageImage,
    MessageCube,
    MessageCoupon,
    MessageCoupons,
    Btns
  },
  data () {
    return {
      VUE_APP_MULTI_COUPON,
      messageType: VUE_APP_MULTI_COUPON ? '發送多張票券' : '發送票券',
      type: '純文字',
      content: null,
      coupon: null,
      coupons: []
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  watch: {
    id: {
      async handler () {
        if (!this.id) {
          return false
        }
        const { messageType, textContent, imageUrl, bubbleContent, bubbleHeader, bubbleImage, bubbleLink, coupon, coupons } = await getapi(`message/${this.id}`)
        switch (messageType) {
          case 'text':
            this.messageType = '活動公告'
            this.type = '純文字'
            this.content = textContent
            break
          case 'image':
            this.messageType = '活動公告'
            this.type = '純圖片'
            this.content = imageUrl
            break
          case 'bubble':
            this.messageType = '活動公告'
            this.type = '圖文訊息'
            this.content = {
              title: bubbleHeader,
              link: bubbleLink,
              image: `${bubbleImage}`,
              content: bubbleContent
            }
            break
          case 'coupon':
            this.messageType = '發送票券'
            this.type = '純文字'
            this.coupon = coupon
            break
          case 'multicoupons':
            this.messageType = '發送多張票券'
            this.type = '純文字'
            this.coupons = coupons
            break
          case 'couponWithText':
            this.messageType = '發送票券並推播'
            this.type = '純文字'
            this.content = textContent
            this.coupon = coupon
            break
        }
      },
      immediate: true
    },
    clear () { this.clean() },
    type () {
      if (this.type === '純圖片' && (typeof this.content) === 'object') {
        this.content = this.content.image
      }
      // this.content = null
    }
  },
  async mounted () {
    if (this.$route.query.coupon) {
      this.messageType = '發送票券'
      this.coupon = await getapi(`couponTemplate/${this.$route.query.coupon}`)
    }
  },
  methods: {
    clean () {
      this.coupons = []
      this.messageType = '活動公告'
      this.type = '純文字'
      this.content = null
      this.coupon = null
    },
    save () {
      this.$emit('save', {
        messageType: this.messageType,
        type: this.type,
        content: this.content,
        coupon: this.coupon,
        coupons: this.coupons
      })
    },
    saveAs () {
      this.$emit('saveAs', {
        messageType: this.messageType,
        type: this.type,
        content: this.content,
        coupon: this.coupon,
        coupons: this.coupons
      })
    }
  }
}
</script>
<style lang="scss">
#RTSQR {
  input[type=radio]:checked {
    background-color: var(--color-pri);
  }
}
#RTRound{
  input[type=radio] {
    border-radius: 20px;
    width: 125px;
  }
}
</style>
<style lang="scss" scoped>
.titlepush {
  font-weight: 400;
  font-size: 25px;
  line-height: 36px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  gap: 30px;
}
.messageBox {
  padding: 28px 41px;
  display: flex;
  flex-direction: column;

}
</style>
